<ui-confirmation-dialog
    #confirmRemoveDialog
    size="small"
    header="Delete Dropdown Option?"
    primaryButtonLabel="Delete"
    secondaryButtonLabel="Cancel"
    primaryButtonType="danger"
>
    <p>{{ 'forms.fields.thisOptionHasBeenSelectedByOneOrMoreEmployeesDeletingItWillResul' | translate }}</p>
</ui-confirmation-dialog>

<form class="app-grid" #form="ngForm">
    <!-- Loader -->
    <div *ngIf="isLoading" class="ui active inverted dimmer">
        <div class="ui loader"></div>
    </div>

    <!-- Name -->
    <mat-form-field class="columns-4">
        <mat-label>{{ 'forms.fields.name' | translate }}</mat-label>
        <input
            matInput
            type="text"
            name="title"
            #name="ngModel"
            required
            [(ngModel)]="field.name"
            placeholder="{{ 'forms.fields.egLicenseNumber' | translate }}"
        />
        <mat-error *ngIf="name.invalid">{{ name.errors | formErrors }}</mat-error>
    </mat-form-field>

    <!-- Description -->
    <mat-form-field class="columns-4">
        <mat-label>{{ 'forms.fields.placeholderText' | translate }}</mat-label>
        <input
            matInput
            name="placeholderText"
            required
            #description="ngModel"
            [(ngModel)]="field.description"
            [disabled]="placeholderInputDisabled"
        />
        <mat-error *ngIf="description.invalid">{{ description.errors | formErrors }}</mat-error>
    </mat-form-field>
    <ui-info
        class="columns-1 margin-top-4"
        text="{{ 'forms.fields.thisWillAppearInsideTheFieldToGiveEmployeesAnExampleO' | translate }}"
    ></ui-info>

    <!-- Type -->
    <div class="columns-4">
        <div class="app-grid">
            <mat-form-field class="columns-11">
                <mat-label appRemoveAriaOwns>{{ 'forms.fields.fieldType' | translate }}</mat-label>
                <mat-select
                    placeholder="{{ 'forms.fields.selectAType' | translate }}"
                    [(ngModel)]="field.type"
                    #rule="ngModel"
                    name="selectedId"
                    required
                    [disabled]="disableFieldType"
                    (selectionChange)="onValidationTypeSelect()"
                >
                    <mat-option [value]="dataFieldTypes.shortText">{{
                        'forms.fields.shortText' | translate
                    }}</mat-option>
                    <mat-option [value]="dataFieldTypes.number">{{ 'forms.fields.number' | translate }}</mat-option>
                    <mat-option [value]="dataFieldTypes.date">{{ 'forms.fields.date' | translate }}</mat-option>
                    <mat-option [value]="dataFieldTypes.boolean">{{ 'forms.fields.yesNo' | translate }}</mat-option>
                    <mat-option [value]="dataFieldTypes.dropdown">{{ 'forms.fields.dropdown' | translate }}</mat-option>
                    <mat-option [value]="dataFieldTypes.longText">{{ 'forms.fields.longText' | translate }}</mat-option>
                </mat-select>
                <mat-error *ngIf="rule.invalid">{{ rule.errors | formErrors }}</mat-error>
            </mat-form-field>
            <ui-info
                class="columns-1 margin-top-4"
                text="{{ 'forms.fields.thisDeterminesTheFormatOfTheFieldContents' | translate }}"
            ></ui-info>
        </div>
    </div>

    <!-- Dropdown options -->
    <ng-container *ngIf="field.type === dataFieldTypes.dropdown">
        <div class="app-grid margin-bottom-2">
            <div class="columns-5 flex justify-space-between">
                <mat-label class="add-asterisk">{{ 'forms.fields.dropdownOptions' | translate }}</mat-label>
                <ng-container *ngIf="dataFieldOptionState.dataFieldOptions.length === 1; else multipleDropdownOptions">
                    <mat-label class="field-options-description margin-left-5">{{
                        {
                            key: 'forms.fields.dataFieldOptionStatedataFieldOptionslengthOptionInList',
                            params: {
                                length: dataFieldOptionState.dataFieldOptions.length,
                            },
                        } | appTranslate
                    }}</mat-label>
                </ng-container>
                <ng-template #multipleDropdownOptions>
                    <mat-label class="field-options-description margin-left-5">{{
                        {
                            key: 'forms.fields.dataFieldOptionStatedataFieldOptionslengthOptionsInList',
                            params: {
                                length: dataFieldOptionState.dataFieldOptions.length,
                            },
                        } | appTranslate
                    }}</mat-label>
                </ng-template>
            </div>
        </div>

        <div class="app-grid margin-bottom-1">
            <app-drag-and-drop-with-deletable-options
                class="columns-5"
                addBorder="true"
                addButtonLabel="Add Dropdown Option"
                maxOptions="50"
                [hideRemoveOnOneItem]="true"
                [emptyOption]="getEmptyDataFieldOption()"
                [options]="dataFieldOptionState.dataFieldOptions"
                (optionsChange)="dataFieldOptionState.trackOptionChanges($event)"
                (optionRemoved)="onOptionRemove($event)"
            ></app-drag-and-drop-with-deletable-options>
        </div>
    </ng-container>

    <ng-container *ngIf="hasMinMax">
        <div class="app-grid columns-12">
            <mat-form-field class="columns-4">
                <mat-label *ngIf="field.type !== dataFieldTypes.number">{{
                    'forms.fields.minimumLength' | translate
                }}</mat-label>
                <mat-label *ngIf="field.type === dataFieldTypes.number">{{
                    'forms.fields.minimumValue' | translate
                }}</mat-label>
                <input matInput type="number" min="0" name="fieldTypeExtraMinLength" [(ngModel)]="field.min" />
            </mat-form-field>

            <mat-form-field class="columns-4">
                <mat-label *ngIf="field.type !== dataFieldTypes.number">{{
                    'forms.fields.maximumLength' | translate
                }}</mat-label>
                <mat-label *ngIf="field.type === dataFieldTypes.number">{{
                    'forms.fields.maximumValue' | translate
                }}</mat-label>
                <input matInput type="number" name="fieldTypeExtraMaxLength" [(ngModel)]="field.max" />
            </mat-form-field>
        </div>
    </ng-container>

    <!-- Field Group -->
    <ng-container *ngIf="showFieldGroup">
        <div class="app-grid">
            <div class="app-grid columns-4">
                <mat-form-field class="columns-11">
                    <mat-label appRemoveAriaOwns>{{ 'forms.fields.fieldGroup' | translate }}</mat-label>
                    <mat-select
                        [(ngModel)]="group"
                        #fieldGroupName="ngModel"
                        name="dataFieldGroupId"
                        (ngModelChange)="onGroupChange()"
                        [compareWith]="compareModels"
                        placeholder="{{ 'forms.fields.selectAGroup' | translate }}"
                        required
                    >
                        <mat-select-trigger *ngIf="group.isPersisted">{{
                            group.translatableName | translate
                        }}</mat-select-trigger>
                        <mat-select-trigger *ngIf="!group.isPersisted">{{
                            'forms.fields.addNewGroup' | translate
                        }}</mat-select-trigger>
                        <mat-option [value]="newFieldGroup" class="create font-medium">
                            <span>{{ 'forms.fields.addNewGroup' | translate }}</span>
                        </mat-option>
                        <mat-option *ngFor="let fieldGroup of fieldGroups" [value]="fieldGroup">
                            <div class="option-body">
                                <span>{{ fieldGroup.translatableName | translate }}</span>
                                <span class="sub-label"> {{ fieldGroup.translatableComponent | translate }} </span>
                            </div>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <ui-info
                    class="columns-1 margin-top-4"
                    text="{{ 'forms.fields.thisIsWhereTheCustomFieldWillShowUpOnTheEmployeesPro' | translate }}"
                ></ui-info>
                <mat-error *ngIf="fieldGroupName.invalid">{{ fieldGroupName.errors | formErrors }}</mat-error>
            </div>
        </div>

        <ng-container *ngIf="group === newFieldGroup">
            <div class="app-grid">
                <mat-form-field class="columns-4">
                    <mat-label>{{ 'forms.fields.groupName' | translate }}</mat-label>
                    <input
                        matInput
                        type="text"
                        name="fieldGroupName"
                        #groupName="ngModel"
                        required
                        [(ngModel)]="group.name"
                        (ngModelChange)="onGroupChange()"
                    />
                    <mat-error *ngIf="groupName.invalid">{{ groupName.errors | formErrors }}</mat-error>
                </mat-form-field>

                <mat-form-field class="columns-4">
                    <mat-label appRemoveAriaOwns>{{ 'forms.fields.groupLocation' | translate }}</mat-label>
                    <mat-select
                        placeholder="{{ 'forms.fields.pleaseSelectAnOption' | translate }}"
                        required
                        #groupComponent="ngModel"
                        name="groupComponent"
                        [(ngModel)]="group.component"
                        (ngModelChange)="onGroupChange()"
                    >
                        <mat-option value="personal">{{ 'forms.fields.personal' | translate }}</mat-option>
                        <mat-option value="job_and_pay">{{ 'forms.fields.jobAndPay' | translate }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="groupComponent.invalid">{{ groupComponent.errors | formErrors }}</mat-error>
                </mat-form-field>
            </div>
        </ng-container>
    </ng-container>

    <!-- Encryption -->
    <div class="columns-12 app-grid align-left">
        <label class="padding-bottom-1"
            >{{ 'forms.fields.fieldEncryption' | translate }}
            <ui-info
                class="padding-left-1"
                text="{{ 'forms.fields.thisMakesTheFieldContentsMoreSecureAndBlursItOutWhen' | translate }}"
            ></ui-info>
        </label>

        <mat-radio-group
            class="columns-12 vertical margin-bottom-2"
            name="encrypt"
            [(ngModel)]="field.isEncrypted"
            aria-label="Encrypt This Field? Use for sensitive data."
        >
            <mat-radio-button [value]="false">{{ 'forms.fields.no' | translate }}</mat-radio-button>
            <mat-radio-button [value]="true">{{ 'forms.fields.yes' | translate }}</mat-radio-button>
        </mat-radio-group>
    </div>

    <!-- Required -->
    <div class="columns-12 flex col align-left padding-bottom-2">
        <mat-label class="padding-bottom-1"
            >{{ 'forms.fields.mandatoryField' | translate }}
            <ui-info
                class="padding-left-1"
                text="{{ 'forms.fields.mandatoryFieldsMustBeFilledOutDuringOnboardingAndWhenE' | translate }}"
            ></ui-info
        ></mat-label>
        <mat-radio-group class="vertical" name="isRequired" [(ngModel)]="field.isRequired">
            <mat-radio-button [value]="false">{{ 'forms.fields.no' | translate }}</mat-radio-button>
            <mat-radio-button [value]="true">{{ 'forms.fields.yes' | translate }}</mat-radio-button>
        </mat-radio-group>
    </div>

    <mat-form-field class="columns-8">
        <mat-label
            appRemoveAriaOwns
            [innerHTML]="'forms.fields.rolesWithThePermissionnbspToEditAndView' | translate"
        ></mat-label>
        <mat-select
            #roles="ngModel"
            (selectionChange)="onRoleChange($event.value)"
            [(value)]="roleIds"
            [ngModel]="roleIds"
            name="roleIds"
            required
            multiple
        >
            <mat-option *ngFor="let role of selectableRoles" [value]="role.id">{{
                role.name | appTranslateOptions: roleNameDisplay
            }}</mat-option>
        </mat-select>
        <mat-error *ngIf="roles.invalid">{{ roles.errors | formErrors }}</mat-error>
    </mat-form-field>

    <ng-container>
        <mat-form-field class="columns-8">
            <mat-label
                appRemoveAriaOwns
                [innerHTML]="'forms.fields.rolesWithThePermissionnbspToOnlyView' | translate"
            ></mat-label>
            <mat-select (selectionChange)="onViewOnlyRoleChange($event.value)" [(value)]="viewOnlyRoleIds" multiple>
                <mat-option *ngFor="let role of viewOnlySelectableRoles" [value]="role.id">{{
                    role.name | appTranslateOptions: roleNameDisplay
                }}</mat-option>
            </mat-select>
        </mat-form-field>
    </ng-container>

    <ng-container>
        <mat-checkbox
            name="isEnabledForDocuments"
            class="flex align-items-center"
            [(ngModel)]="field.isEnabledForDocuments"
            >{{ 'forms.fields.allowThisFieldToBeAddedToDocuments' | translate }}
            <ui-info
                class="padding-left-1"
                text="{{ 'forms.fields.thisFieldWillBeIncludedInTheListOfAvailableFieldsInT' | translate }}"
            ></ui-info>
        </mat-checkbox>
    </ng-container>
</form>
